<div class="timestamp">
  <span>作成日時：{{ activityRecord.created_at }}</span>
  @if (activityRecord.updated_at !== '-') {
    <span>更新日時：{{ activityRecord.updated_at }}</span>
  }
  @if (!layoutService.isTabletDownView.value) {
    <p class="serial">[ {{ page }}/{{ totalPage }} ]</p>
  }
</div>
<div class="title">
  <a class="spen-util-link" [routerLink]="['/activity-records/teacher/', activityRecord.id]">{{ activityRecord.title }}</a>
</div>
@if (isDocumentRecord()) {
  <app-document-detail-teacher
    [document]="activityRecord.record"
    [categoryName]="activityRecord.category_name"
    [marks]="activityRecord.marks"
    [isCompassAnswer]="false"
    [isReadMore]="true"
  >
  </app-document-detail-teacher>
}
@if (isQuestionnaireRecord()) {
  <app-questionnaire-detail-teacher
    [categoryName]="activityRecord.category_name"
    [questionnaire]="activityRecord.record"
    [isReadMore]="true"
  >
  </app-questionnaire-detail-teacher>
}
<div class="page">- {{ page }} -</div>
